export const RobuxProduct = ({
  id,
  price,
  robux,
  dateCreated,
  setCheckoutItem,
}) => {
  return (
    <div className="robux-product-container">
      {Math.floor((new Date() - new Date(dateCreated.toDate())) / 86400000) <
        1 && <div className="new-item">New</div>}
      <div className="robux-product-upper">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2FRobux_2019_Logo_gold.svg.png?alt=media&token=42ab7d0d-53e1-41f9-8f30-c953c6493e3a"
          alt="roblox icon"
          className="robux-product-icon"
        />
        <h2>{robux}</h2>
      </div>
      <div className="robux-product-lower">
        <button
          className="btn-buy"
          onClick={() => {
            // handlePayment();
            setCheckoutItem(id);
          }}
        >
          <img
            src="https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2FIcon_HV_Resource_Gold_2.png?alt=media&token=b18097b0-407b-4668-88e1-fb7e4e2f3696"
            style={{
              height: "20px",
            }}
          />
          {price}
        </button>
      </div>
    </div>
  );
};
